// Vendors
import styled from 'styled-components';

const BackgroundContentComponentStyled = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_350};
  padding: ${({ theme }) => theme.spacing_250} 0;
  text-align: center;
  width: 100%;
`;
BackgroundContentComponentStyled.displayName = 'AuthWatcherProviderStyled';

export { BackgroundContentComponentStyled };
